// extracted by mini-css-extract-plugin
export default {"cc-popbox-imgZoom":"uYtsUpzf","cc-content-new":"BYX7qGK9","cc-content-photo":"Ftj3IaLx"};